/* eslint-disable import/prefer-default-export */
import axios from 'axios';
import { getConfig, getUserSummaryConfig, getCoreConfig } from '../../../../../config/apiConfig';
import { getActivitiesAndTaskConfigurations } from '../../../../configuration/activitiesAndTasks/services/activitiesAndTaskConfigurationService';
import getLogger from '../../../../../utils/logger';

const getSettingValueFromContext = (settingContext, settingKey) => {
  if (settingContext && settingContext.settings) {
    const settingObj = settingContext.settings.filter((setting) => setting.key === settingKey)[0];
    return settingObj.value;
  }
  return false;
};

export const getActivitiesAndTasksDomainSettings = getActivitiesAndTaskConfigurations;

export const getUserLearningData = async (payload, settingsData) => {
  const config = await getUserSummaryConfig();
  let isV2Enabled = 'false';
  isV2Enabled = getSettingValueFromContext(settingsData, 'ENABLE_EXPERIENCEHUB_VERSION_V2');
  const requestUrl =
    isV2Enabled.toLowerCase() === 'true' ? 'api/v2/experiencehub' : 'api/v1/experiencehub';
  return axios
    .post(requestUrl, payload, config)
    .then(async (response) => {
      return response.data;
    })
    .catch(() => {
      return null;
    });
};

export const getPastDueCount = async (payload) => {
  const config = await getUserSummaryConfig();
  const requestUrl = 'api/v2/getmylearningpastduecount';
  return axios
    .post(requestUrl, payload, config)
    .then(async (response) => {
      return {
        data: response.data
      };
    })
    .catch(() => {
      return null;
    });
};

export const trackUserPermission = async () => {
  const config = await getCoreConfig();
  const requestUrl = `api/profiledata/GetUserPermissions?securitySectionTM=&securitySectionLM=CanManageOthersRoster&useEmulatingUserId=true`;
  return axios
    .get(requestUrl, config)
    .then(async (response) => {
      if (
        response != null &&
        response.data.Permission.indexOf('DecertifyAcquiredCertification') !== -1
      ) {
        return true;
      }
      return false;
    })
    .catch((err) => {
      getLogger().error(err);
      return null;
    });
};

export const getCalendarData = async () => {
  const config = await getUserSummaryConfig();
  const requestUrl = `api/v2/GetCalendarData`;
  return axios
    .get(requestUrl, config)
    .then(async (response) => {
      return response.data;
    })
    .catch(() => {
      return null;
    });
};

export const registerForActivity = async (payload) => {
  const config = await getConfig();
  const requestUrl = `api/rcore/myActivities/register`;
  return axios
    .post(requestUrl, payload, config)
    .then(async (response) => {
      return response.data;
    })
    .catch(() => {
      return null;
    });
};

export const getCertificate = async (activityId, attemptId) => {
  const config = await getConfig();
  const requestUrl = `api/ConfigurationApi/GetActivitiyCertificateDetails?activityId=${activityId}&attemptId=${attemptId}`;
  return axios
    .get(requestUrl, config)
    .then(async (response) => {
      return response.data;
    })
    .catch(() => {
      return null;
    });
};

export const downloadCertificate = async (activityId, attemptId) => {
  const config = await getConfig();
  const requestUrl = `api/ConfigurationApi/GetExportCertificateToPDf?activityId=${activityId}&attemptId=${attemptId}`;
  return axios
    .get(requestUrl, config)
    .then(async (response) => {
      return response.data;
    })
    .catch(() => {
      return null;
    });
};

/**
 * Gets activity type details
 * @param {Number} attemptId
 *
 */
export const getLateCompletionDataByAttempt = async (attemptId) => {
  if (attemptId === undefined) {
    return null;
  }
  // Get auth header config
  const config = await getConfig();
  const url = `/api/tracklatecompletions/${attemptId}/`;
  return axios
    .get(url, config)
    .then(async (resp) => {
      return resp;
    })
    .catch((err) => {
      getLogger().error(err);
      return {};
    });
};

export const saveLateComments = async (lateAttemptComments) => {
  // Get auth header config
  const config = await getConfig();
  try {
    const resp = await axios.post(
      `/api/tracklatecompletions/savelatecomments`,
      lateAttemptComments,
      config
    );
    return resp;
  } catch (err) {
    getLogger().error(err);
    return null;
  }
};

export const cancelInterest = async (payload) => {
  const config = await getUserSummaryConfig();
  const requestUrl = `/api/v2/CancelInterest`;
  try {
    const resp = await axios.post(requestUrl, payload, config);
    return resp;
  } catch (err) {
    getLogger().error(err);
    return null;
  }
};

export const getDecertificationReasons = async () => {
  const config = await getUserSummaryConfig();
  const requestUrl = `api/v2/GetDecertificationReasons`;
  return axios
    .get(requestUrl, config)
    .then(async (response) => {
      return response.data;
    })
    .catch((err) => {
      getLogger().error(err);
      return null;
    });
};

export const decertifyActivity = async (payload) => {
  const config = await getUserSummaryConfig();
  const requestUrl = `/api/v2/DecertifyReason`;
  try {
    const resp = await axios.post(requestUrl, payload, config);
    return resp;
  } catch (err) {
    getLogger().error(err);
    return null;
  }
};
